// extracted by mini-css-extract-plugin
module.exports = {"FAQ":"FAQ_FAQ__MfPwT","Title":"FAQ_Title__ESGI_","FAQItems":"FAQ_FAQItems__9ik84"};